const COOKIE_NAME = "lapaire_lang";
const MAX_AGE = 31536000; // 1 year

/**
 * Synchronous language detection — zero network cost.
 * Priority: 1) persisted cookie  2) navigator.languages  3) "fr" fallback
 */
export function detectLang(): "fr" | "en" {
  if (typeof document === "undefined" || typeof navigator === "undefined") return "fr";

  // 1. Persisted cookie
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  if (match) {
    const v = decodeURIComponent(match[1] ?? "");
    if (v === "en") return "en";
    return "fr";
  }

  // 2. Browser language preference
  const langs = navigator.languages ?? [navigator.language];
  for (const l of langs) {
    if (l.startsWith("en")) return "en";
    if (l.startsWith("fr")) return "fr";
  }

  // 3. Default
  return "fr";
}

export function setLangCookie(lang: "fr" | "en"): void {
  if (typeof document === "undefined") return;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(lang)}; max-age=${MAX_AGE}; path=/; SameSite=Lax`;
}
